import { Settings } from '@streamr/tv-engine/~/settings';
import { AppAudioDecoder } from './AppAudioDecoder';
import { OpusAudioDecoder } from './OpusAudioDecoder';
let webCodecsOpusSupportedResult;
/**
 * Safari's AudioDecoder.isConfigSupported() can lie about Opus support,
 * so we actually try to configure a test decoder to verify.
 */
async function isWebCodecsOpusSupported() {
    if (webCodecsOpusSupportedResult !== undefined) {
        return webCodecsOpusSupportedResult;
    }
    if (typeof globalThis.AudioDecoder === 'undefined') {
        webCodecsOpusSupportedResult = false;
        return false;
    }
    try {
        const config = {
            codec: Settings.audioCodec,
            sampleRate: Settings.audioSampleRate,
            numberOfChannels: Settings.audioNumberOfChannels,
        };
        const support = await AudioDecoder.isConfigSupported(config);
        if (!support.supported) {
            webCodecsOpusSupportedResult = false;
            return false;
        }
        const testDecoder = new AudioDecoder({
            output: () => { },
            error: () => { },
        });
        try {
            testDecoder.configure(config);
            testDecoder.close();
            webCodecsOpusSupportedResult = true;
            return true;
        }
        catch {
            testDecoder.close();
            webCodecsOpusSupportedResult = false;
            return false;
        }
    }
    catch {
        webCodecsOpusSupportedResult = false;
        return false;
    }
}
export async function createAudioDecoder(trackId, codec = Settings.audioCodec) {
    if (codec === Settings.audioCodec) {
        const opusSupported = await isWebCodecsOpusSupported();
        if (!opusSupported) {
            console.log('[createAudioDecoder] WebCodecs Opus decoding not supported, using OpusAudioDecoder');
            return new OpusAudioDecoder(trackId, codec);
        }
    }
    return new AppAudioDecoder(trackId, codec);
}
